import { createAction, props } from '@ngrx/store';
import { IApiConfigurationResponse } from 'src/app/api/interfaces/configuration.interface';

export const setInitialConfigurationsData = createAction(
  '[API] set initial configurations data Success',
  props<{ responseData: IApiConfigurationResponse }>()
);
export const updateConfigurationData = createAction(
  '[API] update configurations data Success',
  props<{ responseData: IApiConfigurationResponse }>()
);
